export const USER_UPDATE = "USER_UPDATE";

type TypeRole = "CANDIDATE" | "CANDIDATE_EPG" | "STUDENT" | "STUDENTCLASS";

export type UserType = {
  id: string;
  email: string;
  code: string;
  firstName: string;
  lastName: string;
  document: string;
  properties: any;
  role: TypeRole;
  commonCourses?: any[];
};

export type StatusType = "idle" | "pending" | "success" | "error";

type UserUpdateAction = {
  type: typeof USER_UPDATE;
  payload: UserType;
};

export type UserStateType = {
  data: UserType | null;
  status: StatusType;
};

export type UserActionsTypes = UserUpdateAction;
